import type { VariantProps } from 'class-variance-authority';
import type { ComponentProps } from 'react';
import { cn } from '../../common/functions/cn';
import { buttonVariants } from './button-variants';

export type ButtonProps = ComponentProps<'button'> & VariantProps<typeof buttonVariants>;

const Button = ({ className, variant = 'default', size = 'default', ...props }: ButtonProps) => (
  <button data-slot="button" type="button" className={cn(buttonVariants({ variant, size, className }))} {...props} />
);

export { Button };
